import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer style={{
      backgroundColor: 'var(--white)',
      borderTop: '1px solid var(--gray-medium)',
      padding: '20px 0',
      textAlign: 'center',
      marginTop: 'auto'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px'
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'var(--gray-dark)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}>
          {t('Built with affection')}
          <span style={{ 
            color: 'var(--primary-blue)', 
            fontSize: '16px' 
          }}>
            ♥
          </span> 
          {t('by')}{' '}
          <a 
            href="https://www.mindyards.com" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: 'var(--primary-blue)',
              textDecoration: 'none',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
          >
            Mindyards
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
